import React from 'react'
import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import useAccess from '../../../utils/hooks/useAccess'
import { GROUPS, MODULES } from '../../../utils/constants/roles'
import { FavoritesFuelStationsService } from '../../../services/favorites-fuel-stations/favoritesFuelStations.service'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions'
import DataTableComp from '../../../components/common/data-table/DataTableComp'
import MainCommonView from '../../../components/common/MainCommonView'
import FavoriteButton from '../../../components/common/buttons/FavoriteButton'
import { bodyCurrencyInput } from '../../../components/common/data-table/column-types/ColumnTypes'
import './fuelStationsFavorites.scss'
import AppSection from '../../../component/layout/AppSection.tsx'
import AppTabMenu from '../../../component/layout/AppTabMenu.tsx'
import { fuelStationsMenu } from '../../../utils/constants/navlinks-Menu'

const FuelStationsFavorites = () => {
  const { formatMessage: msg } = useIntl()

  const { canDelete } = useAccess()
  const dataFacade = useHandlerBasicActions({
    getAll: FavoritesFuelStationsService.getAll,
    sortFieldInitial: 'addressInfo.province',
    removeAction: FavoritesFuelStationsService.removeFavorite,
    rowsPerPageInitial: 100,
  })

  const buttonFavorite = (rowData) => (
    <FavoriteButton
      isFavorite="true"
      onclick={() => dataFacade.remove(rowData?._id)}
    />
  )

  const headerOptions = {
    title: msg({ id: 'competencies' }),
    searchOptions: dataFacade?.searchOptions,
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const dataTable = (
    <DataTableComp
      loading={dataFacade?.loading}
      pagerOptions={pagerOptions}
      tableOptions={{
        className: 'table-with-menu',
        value: dataFacade?.data?.resp,
        size: 'small',
        ...dataFacade?.sortOptions,
      }}
      columns={[
        <Column sortable field="label" header={msg({ id: 'sign' })} />,
        <Column
          sortable
          field="addressInfo.province"
          header={msg({ id: 'province' })}
        />,
        <Column
          sortable
          field="addressInfo.locality"
          header={msg({ id: 'locality' })}
        />,
        <Column field="addressInfo.address" header={msg({ id: 'address' })} />,
        <Column
          field="prices.GOA"
          header="GOA"
          body={(rowData) => bodyCurrencyInput(rowData?.prices?.GOA)}
        />,
        <Column
          field="prices.GOAPLUS"
          header="GOAPLUS"
          body={(rowData) => bodyCurrencyInput(rowData?.prices?.GOAPLUS)}
        />,
        <Column
          field="prices.G95"
          header="G95"
          body={(rowData) => bodyCurrencyInput(rowData?.prices?.G95)}
        />,
        canDelete(MODULES.FUELSTATIONS, GROUPS.FAVORITE) && (
          <Column
            body={buttonFavorite}
            className="row-delete"
            exportable={false}
          />
        ),
      ]}
    />
  )

  return (
    <AppSection
      /* refactor this */
      header={<AppTabMenu options={fuelStationsMenu} />}
      headerOptions={headerOptions}
      dataFacade={dataFacade}
    >
      {dataTable}
    </AppSection>
  )
}

export default FuelStationsFavorites
